import { useMsal, useAccount } from '@azure/msal-react';
import { useEffect, useState } from 'react';

import { Button, Grid, Icon } from 'semantic-ui-react';

import { v4 as uuidv4 } from 'uuid';

import { DashboardMobileFilterSection } from './DashboardMobileFilterSection';

import { t } from '../../utils/resources';
import { ROUTE_ROOT } from '../../utils/routes';
import './DashboardMobile.less';
import { constructSearchQueryFromFilters, getOptionsForLevel } from '../../utils/helpers';
import { saveDashboardFiltersUserChoice } from './helper';
import { NavigationDataProps } from '../../types/types';
import { POSImage } from '@publicisgroupe/p-os-components';

export const DashboardMobile = (props: NavigationDataProps) => {
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const { filters, filterNames } = props;
  const [selectedFilterOptions, setSelectedFilterOptions] = useState<any>({});
  const [currentLevel, setCurrentLevel] = useState<number>(0);
  const [currentFilter, setCurrentFilter] = useState<string>('');
  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
  const [showOptions, setShowOptions] = useState<boolean>(false);
  const [enableDoneButton, setEnableDoneButton] = useState<boolean>(false);

  const getOptions = (level: number): string[] => {
    const options = getOptionsForLevel(level, filters, filterNames, selectedFilters, false);
    if (options && options.length > 0) {
      return options.map((opt: any) => opt.text);
    } else return [];
  };
  const setSelectedOption = (selectedOption: string, filter: string) => {
    setSelectedFilterOptions({ ...selectedFilterOptions, [filter]: selectedOption });
  };
  const getFilterName = (dir: string): string => {
    if (dir === 'prev') {
      return filterNames.length > 0 && currentLevel - 1 >= 0 ? filterNames[currentLevel - 1] : '';
    } else if (dir === 'next') {
      return filterNames.length > 0 && currentLevel + 1 < filterNames.length
        ? filterNames[currentLevel + 1]
        : '';
    } else {
      return filterNames.length > 0 ? filterNames[currentLevel] : '';
    }
  };
  const toggleShowOptions = (level: number) => {
    if (level >= 0) {
      setCurrentLevel(level);
      setShowOptions(true);
      if (filterNames.length > 0 && level < filterNames.length) {
        setCurrentFilter(filterNames[level].toString());
      }
    }
  };
  const saveFiltersAndRedirect = () => {
    const newSearchQuery = constructSearchQueryFromFilters(selectedFilters);
    localStorage.setItem('initial-dashboard-filters', newSearchQuery);
    window.location.href = `${ROUTE_ROOT}?${newSearchQuery}`;
  };

  useEffect(() => {
    if (filterNames.length > 0) {
      const optedFilters: string[] = [];
      Object.keys(selectedFilterOptions).forEach((key) => {
        optedFilters.push(selectedFilterOptions[key]);
      });

      if (Object.keys(selectedFilterOptions).length === filterNames.length)
        setEnableDoneButton(true);
      else setEnableDoneButton(false);

      setSelectedFilters(optedFilters);
    }
  }, [selectedFilterOptions, filterNames]);
  return (
    <>
      <div className="mobile-dashboard">
        <Grid.Column>
          <div className="brand-section">
            <POSImage src="webframe/Logo-Dark-bg.svg" className="dashboard-brand-img" />
          </div>
          <div className="dashboard-welcome-text">
            <h4>
              {t('Dashboard.Welcome')} <br />
              <span>{account?.name}</span>
            </h4>
            <p className="sub-title">{t('DashboardMobile.SubTitle')}</p>
          </div>
        </Grid.Column>
        <Grid.Column>
          <div className="all-filters">
            {filterNames.map((filter: string, idx: number) => (
              <Grid.Row
                key={`filter-${uuidv4()}`}
                id={`filter_${idx}_${filter}`}
                className="filter-section"
              >
                <span className="filter-title">{filter.toString().toUpperCase()}</span>
                <div className="filter-dropdown" onClick={() => toggleShowOptions(idx)}>
                  <span className="selected-text">{selectedFilterOptions[filter]}</span>
                  <Icon className="pos arrow-right" />
                </div>
              </Grid.Row>
            ))}
            <Grid.Row className="footer-section" columns={1}>
              <Grid.Column className="userchoice">
                <label>
                  <input
                    type="checkbox"
                    onClick={(event: any) => saveDashboardFiltersUserChoice(event)}
                  />
                  {t('Dashboard.UserChoiceText')}
                </label>
              </Grid.Column>
              <Grid.Column>
                <Button
                  className={`btn-done ${enableDoneButton ? '' : 'disable-section'}`}
                  onClick={() => saveFiltersAndRedirect()}
                >
                  <Icon className="pos check icon-check" size="large" />
                  {t('DashboardMobile.Done')}
                </Button>
              </Grid.Column>
            </Grid.Row>
          </div>
        </Grid.Column>
        <DashboardMobileFilterSection
          showFilterOptions={showOptions}
          navigateToFilters={() => setShowOptions(false)}
          filter={getFilterName('')}
          previousFilter={getFilterName('prev')}
          nextFilter={getFilterName('next')}
          filterOptions={getOptions(currentLevel)}
          activeOption={selectedFilterOptions[currentFilter]}
          handleSelectedOption={(selectedOption: string, filter: string) =>
            setSelectedOption(selectedOption, filter)
          }
          traversePrevSection={() => {
            setShowOptions(false);
            toggleShowOptions(currentLevel - 1 >= 0 ? currentLevel - 1 : -1);
          }}
          traverseNextSection={() => {
            setShowOptions(false);
            toggleShowOptions(currentLevel + 1 < filterNames.length ? currentLevel + 1 : -1);
          }}
          saveFiltersAndRedirect={() => saveFiltersAndRedirect()}
          filterKeys={filterNames}
        />
      </div>
    </>
  );
};
